<template lang="pug">
.common-card
  .common-card-header
    .title {{ dataForm.batchNo }}
    .join-num {{ dataForm.participantNum }}人参与
  .common-card-body(v-if="dataForm.lotteryPublicityList.length > 0")
    .lottery-sence-item(
      v-for="(item, index) in dataForm.lotteryPublicityList"
      :key="index"
    )
      .lottery-sence-header
        .header-left
          .logo(:style="`background-image: url(${item.icon});`")
          .name {{ item.prizeName }}
        .header-right(@click="handleUnfoldClick(index)")
          .win-num {{ item.numberWinners }}人中奖
          img.arrow-icon(
            :class="{ 'arrow-icon-rotate': curUnfoldIdx === index }"
            src="https://m.hellobike.com/resource/gallery/833/RjI68JyWTD.png"
            alt=""
          )
      .lottery-sence-content(v-if="item.prizeList && item.prizeList.length > 0")
        .win-user-list(v-show="curUnfoldIdx === index")
          .user-item(v-for="(prize, idx) in item.prizeList" :key="idx")
            .number {{ prize.mobile }}
            .icon(
              v-if="prize.ratioIcon"
              :style="`background-image: url(${prize.ratioIcon})`"
            )
            .my-icon(v-if="prize.isMyself") {{ `(我)` }}
</template>

<script>
export default {
  props: {
    // 卡片数据
    dataForm: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 当前展开的卡片索引
      curUnfoldIdx: 0,
    };
  },
  mounted() {},
  methods: {
    // 展开/收起
    handleUnfoldClick(index) {
      // 如果点击的是当前展开的项目，则折叠它
      if (this.curUnfoldIdx === index) {
        this.curUnfoldIdx = -1;
      } else {
        // 否则展开点击的项目
        this.curUnfoldIdx = index;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.common-card {
  padding: 0.12rem 0.12rem 0.04rem;
  width: 100%;

  &:last-child {
    padding-bottom: 0.2rem;
  }

  .common-card-header {
    display: flex;
    align-items: center;

    .title {
      font-weight: 500;
      font-size: 0.14rem;
      line-height: 0.2rem;
    }

    .join-num {
      font-weight: 500;
      font-size: 0.12rem;
      color: #000;
      opacity: 0.4;
      margin-left: 0.12rem;
      line-height: 0.17rem;
    }
  }

  .common-card-body {
    margin-top: 0.14rem;
  }

  .lottery-sence-item {
    margin-bottom: 0.16rem;

    &:last-child {
      margin-bottom: 0;
    }

    .lottery-sence-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .header-left {
        display: flex;
        align-items: center;

        .logo {
          overflow: hidden;
          width: 0.32rem;
          height: 0.32rem;
          border-radius: 0.06rem;
          border: 1px solid #f2f2f2;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        .name {
          margin-left: 0.14rem;
          font-size: 0.14rem;
          line-height: 0.2rem;
          color: #000;
        }
      }

      .header-right {
        display: flex;
        align-items: center;

        .win-num {
          font-weight: 500;
          font-size: 0.12rem;
          line-height: 0.17rem;
          color: #5a6066;
        }

        .arrow-icon {
          margin-left: 0.02rem;
          width: 0.12rem;
          height: 0.12rem;
          vertical-align: bottom;

          &.arrow-icon-rotate {
            transform: rotate(180deg);
          }
        }
      }
    }

    .lottery-sence-content {
      margin-top: 0.05rem;
      padding-left: 0.39rem;

      .win-user-list {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0.2rem 0.1rem;
        padding: 0.2rem 0.24rem;
        background-color: #f7f9fa;
        border-radius: 0.12rem;
      }

      .user-item {
        display: flex;
        align-items: center;
        height: 0.17rem;

        .number {
          font-weight: 500;
          font-size: 0.12rem;
          line-height: normal;
          color: #000;
        }

        .icon {
          transform: translateY(-0.03rem);
          margin-left: 0.04rem;
          width: 0.2rem;
          height: 0.17rem;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        .my-icon {
          display: flex;
          align-items: center;
          transform: translateY(-0.01rem);
          margin-left: 0.05rem;
          color: #879099;
          font-size: 0.11rem;
        }
      }
    }
  }
}
</style>
